import React from "react";
import { Link } from 'react-router-dom';
import {
  FaInstagram,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
} from "react-icons/fa";
import Logo from "../image/Logo_Nav.webp";
import FooterBg from "../image/FooterBackground.webp";
import "../App.css";

export default function Footer() {
  return (
    <footer className="wa-footer position-relative" style={{
      background: `linear-gradient(135deg, rgba(6, 18, 36, 0.92) 0%, rgba(3, 8, 18, 0.98) 100%), url(${FooterBg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed'
    }}>
      <div className="container py-5 position-relative z-1">
        <div className="row g-5">
          {/* Column 1: Brand & Social */}
          <div className="col-lg-4 col-md-6 mt-0 mb-0 mb-md-0 mb-sm-3 mb-3">
            <img src={Logo} alt="Shree Kamdhenu Furniture" className="footer-logo mb-4 rounded-3" style={{ maxWidth: '180px' }} />
            <p className="footer-desc mb-4 text-light opacity-75" style={{ lineHeight: '1.8' }}>
              Providing Premium Steel & Box Beds, Laser Art Cupboards, And Storage Solutions — Built On Quality, Trust, And Reliability.
            </p>
            <div className="footer-social-icons">
              {/* <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="footer-social"><FaFacebookF /></a> */}
              <a href="https://www.instagram.com/kamdhenusteelindustries1995/" target="_blank" rel="noopener noreferrer" className="footer-social"><FaInstagram /></a>
              <a href="https://wa.me/919924382499?text=Hello!%20I%20would%20like%20to%20inquire%20about%20Shree%20Kamdhenu%20Furniture." target="_blank" rel="noopener noreferrer" className="footer-social" title="Chat on WhatsApp"><FaWhatsapp /></a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="col-lg-3 col-md-6 mt-md-0 mt-sm-4 mt-4">
            <h5 className="footer-title">Quick Link :</h5>
            <ul className="footer-links list-unstyled mt-4">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/collections">Our Products</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/clients">Our Clients</Link></li>
              <li><Link to="/infrastructure">Project Gallery</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Column 3: Contact Info */}
          <div className="col-lg-5 col-md-12 mt-md-0 mt-lg-0 mt-md-5 mt-4">
            <div className="mb-4">
              <h6 className="footer-subtitle">Location :</h6>
              <div className="d-flex align-items-start gap-2 text-light opacity-75 mt-2">
                <FaMapMarkerAlt className="mt-1 flex-shrink-0" />
                <span>
                  <a href="https://share.google/wGLZ3vJLBz6zjMhCd" target="_blank" rel="noopener noreferrer" className="text-light text-decoration-none" style={{ opacity: 0.9 }}>
                    Block No.221, New Ring Road, <br className="d-none d-sm-inline" />
                    Saniya Kosmada Chokdi, Kosmada - 395006.
                  </a>
                </span>
              </div>
            </div>

            <div className="mb-4">
              <h6 className="footer-subtitle">Email Us :</h6>
              <div className="d-flex align-items-center gap-2 text-light opacity-75 mt-2">
                <FaEnvelope className="flex-shrink-0" />
                <span style={{ wordBreak: 'break-all' }}>
                  <a href="mailto:kamdhenusteelindustries99@gmail.com" className="text-light text-decoration-none" style={{ opacity: 0.9 }}>kamdhenusteelindustries99@gmail.com</a>
                </span>
              </div>
            </div>

            <div className="">
              <h6 className="footer-subtitle">Call Us :</h6>
              <div className="d-flex align-items-start gap-2 text-light opacity-75 mt-2">
                <FaPhoneAlt className="mt-1 flex-shrink-0" />
                <span>
                  <a href="tel:+917202057575" className="text-light text-decoration-none" style={{ opacity: 0.9 }}>+91 72020 57575</a> (Customer Care)<br />
                  <a href="tel:+919624882499" className="text-light text-decoration-none" style={{ opacity: 0.9 }}>+91 96248 82499</a> (Vikram Sakariya)<br />
                  <a href="tel:+919924382499" className="text-light text-decoration-none" style={{ opacity: 0.9 }}>+91 99243 82499</a> (Rakshit Sakariya)
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="footer-bottom">
        <div className="container py-2 text-center">
          <div className="footer-copyright">
            © {new Date().getFullYear()} Shree Kamdhenu Furniture. All rights reserved. Powered by <a href="https://liontouchwebpark.com/" target="_blank" rel="noopener noreferrer" className="text-light text-decoration-none" style={{ opacity: 0.9 }}>Liontouch Webpark.</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
